<template>
  <div class="setting-main-container">
    <div class="card setting-card">
      <div class="page-header">
        <h3 class="page-title">{{ $t('funders.billing_address') }}</h3>
      </div>
      <div class="row">
        <div class="col-md-6 mb-4">
          <label class="form-label">{{ $t('funders.name') }}</label>
          <p v-if="viewFunder && viewFunder.billing_address && viewFunder.billing_address.name !=null">{{ viewFunder.billing_address.name }}</p>
        </div>
        <div class="col-md-6 mb-4">
          <label class="form-label">{{ $t('funders.country') }}</label>
          <p v-if="viewFunder && viewFunder.billing_address && viewFunder.billing_address.country !=null">{{ viewFunder.billing_address.country.name }}</p>
        </div>
        <div class="col-md-6 mb-4">
          <label class="form-label">{{ $t('funders.state') }}</label>
          <p v-if="viewFunder && viewFunder.billing_address && viewFunder.billing_address.state !=null">{{ viewFunder.billing_address.state }}</p>
        </div>
        <div class="col-md-6 mb-4">
          <label class="form-label">{{ $t('funders.city') }}</label>
          <p v-if="viewFunder && viewFunder.billing_address && viewFunder.billing_address.city !=null">{{ viewFunder.billing_address.city }}</p>
        </div>
        <div class="col-md-6 mb-4">
          <label class="form-label">{{ $t('general.street_1') }}</label>
          <p v-if="viewFunder && viewFunder.billing_address && viewFunder.billing_address.address_street_1 !=null">{{ viewFunder.billing_address.address_street_1 }}</p>
        </div>
        <div class="col-md-6 mb-4">
          <label class="form-label">{{ $t('general.street_2') }}</label>
          <p v-if="viewFunder && viewFunder.billing_address && viewFunder.billing_address.address_street_2 !=null">{{ viewFunder.billing_address.address_street_2 }}</p>
        </div>

        <div class="col-md-6 mb-4">
          <label class="form-label">{{ $t('funders.phone') }}</label>
          <p v-if="viewFunder && viewFunder.billing_address && viewFunder.billing_address.phone !=null">{{ viewFunder.billing_address.phone }}</p>
        </div>
        <div class="col-md-6 mb-4">
          <label class="form-label">{{ $t('funders.zip_code') }}</label>
          <p v-if="viewFunder && viewFunder.billing_address && viewFunder.billing_address.zip !=null">{{ viewFunder.billing_address.zip }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'

export default {
  mixins: [validationMixin],
  data () {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapGetters('funder', [
      'viewFunder'
    ])
  },
  created () {
  },
  validations: {},
  mounted () {},
  methods: {}
}
</script>
